<footer class="recaptcha-attribution">
  Diese Seite ist durch reCAPTCHA geschützt. Es gelten die
  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Datenschutzerklärung</a> und die
  <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Nutzungsbedingungen</a> von Google.
</footer>
